import React from "react";
import {
  AutocompleteInput,
  Edit,
  ReferenceInput,
  // SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";
// Local
import {
  //
  BoolNumInput,
  // NonInput,
} from "../../components";
import { selectAllTarget } from "../../lib";
import { MsgRuleInputs } from "./MsgRuleInputs";

export const MsgTemplateEdit = props => {
  // console.log("PROPS", props);
  return (
    <Edit mutationMode="pessimistic" {...props}>
      <SimpleForm redirect="show">
        <TextInput
          source="name"
          label="Template name"
          autoFocus
          fullWidth
          isRequired
          defaultValue="New template"
          onFocus={selectAllTarget}
        />
        <TextInput
          source="description"
          label="Template description"
          fullWidth
          defaultValue=""
        />
        <ReferenceInput
          source="msgTypeId"
          reference="msg_types"
          isRequired
          label="Message type"
          fullWidth
          editable={false}
          disabled
        >
          <AutocompleteInput optionText="name" readOnly />
        </ReferenceInput>
        <BoolNumInput
          source="isDefault"
          defaultValue={0}
          label="Use this template as the default for 'Message type'"
          fullWidth
        />
        <MsgRuleInputs />
      </SimpleForm>
    </Edit>
  );
};
